import React from 'react'
import {Switch, Route} from 'react-router-dom'

import CalendarView from './Calendar'
import ListView from './List'
import BookingView from './Booking'
import BookingProductDeliveryView from './ProductDelivery'
import BookingDeliveryView from './Delivery'
import BookingAssetsView from './Assets'

const Bookings = ({match}) => {
  return (
    <Switch>
      <Route path={`${match.url}/calendar`} component={CalendarView} />
      <Route path={`${match.url}/:id/delivery/:productId`} component={BookingProductDeliveryView} />
      <Route path={`${match.url}/:id/delivery`} component={BookingDeliveryView} />
      <Route path={`${match.url}/:id/assets`} component={BookingAssetsView} />
      <Route path={`${match.url}/:id`} component={BookingView} />
      <Route path="/" component={ListView} />
    </Switch>
  )
}

export default Bookings
